import $ from 'jquery';
import Bloodhound from 'vendor/typeahead'; // Load typeahead jQuery plugin
import Mustache from 'mustache';
import Keyboard from 'styleguide/modules/keyboard';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import '../modules/abtest/smart-filters';

const rcProps = window.rcProps;
var $backButton;
var backButtonPresent;

export default (function() {
	function initTypeahead() {

		// Products
		var products = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.obj.whitespace('productName'),
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: '/r/ajax/VisualSearch.jsp?q=%QUERY&d=' + rcProps.get('department'),
				wildcard: '%QUERY'
			}
		});


		// Text Suggestions
		var textSuggestions = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.obj.whitespace('searchTerm'),
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: '/r/ajax/TextSuggestions.jsp?q=%QUERY&d=' + rcProps.get('department'),
				wildcard: '%QUERY'
			}
		});

		$backButton = $('#nav-go-back-btn');
		backButtonPresent = $backButton.is(':visible');

		let recentSearchCount = 0;

		$.get(window.rcProps.search.recentSearchHref).done(function(recentSearchJson) {
			if (Array.isArray(recentSearchJson)) {
				const $ul = $('<ul class="ui-list n-block-grid--2-textSuggestions">');

				recentSearchJson.splice(0, rcProps.get('search.recentSearchLimit')).forEach(function(recentSearch) {
					$ul.append(Mustache.render(rcProps.get('search.recentSearchTemplate'), {
						searchText: recentSearch.searchText,
						href: recentSearch.href
					}));

					recentSearchCount++;
				});

				$('#recent-searched-viewed').css({
					'position': 'relative',
					'top': '100%',
					'left': '0px',
					'z-index': '100',
					'width': '100%',
					'display': 'inline-block'
				}).append($ul);
			}
		});


		// Sets up the 'search' button to toggle the search area and set focus.
		$('#tr_top_search_btn').click(function () {
			var $this = $(this);
			var $toggleEl = $($this.attr('data-toggle'));
			var $input = $('.js-site-search__textbox');
			var $focusInput = $input.is(':visible');

			$toggleEl.slideToggle();

			// On open
			if ($focusInput) {
				$input.focus();

				if(backButtonPresent) {
					$backButton.hide();
				}
        
				$('.js-horizontal-scroll').horizontalScroll();
				setTimeout(function() {
          			$('.js-search-horizontal-scroll').horizontalScroll('showImages');
				});
			}

			logEngagement('search_engagement');
		});

		var sources = [
			{
				hint: false,
				highlight: true,
				minLength: rcProps.get('search.minLengthBeforeSuggesting'),
				classNames: {
					menu: 'site-search__results',
					highlight: 'site-search__highlight',
					dataset: 'g n-block-grid--2'
				}
			},
			{
				name: 'textSuggestions',
				display: function (obj) {
					return obj.suggestion;
				},
				source: textSuggestions,
				templates: {
					suggestion: (function () {
						var template = rcProps.get('search.text.templates.line');
						return function (data) {
							return Mustache.render(template, {
                                suggestion: data.suggestion,
                                isBrand: data.termType === 'Brand',
                                isWomens: /^w.*/i.test(data.gender)
                            });
						}
					}())
				},
				limit: recentSearchCount === 0
					? rcProps.get('search.text.defaultCount')
					: rcProps.get('search.text.limit') - Math.min(recentSearchCount, rcProps.get('search.recentSearchLimit'))
			}
		];

	//separate func for finding search product headers
    function switchInnerProductRecsHed() {
      $(function() {
        $('.site-search__results > .ui-list.horizontal-scroll.u-flex > .product-recs__hed').each(function() {
          $(this).parent().before(this);
        }); 
      });
    }

	function checkRecsScrollPos() {
      var recScrollPosInterval = setInterval(function(){
        var $recsScroll = $('.site-search__results').find('.horizontal-scroll');
        if ($recsScroll.scrollLeft() === 0 && $('.site-search__results').css('display') != 'none') {
          clearInterval(recScrollPosInterval);
        }
        $recsScroll.scrollLeft(0,0);
      },1);
    }
		if(rcProps.get('search.showVisualSuggestions')) {
      sources.push({
        name: 'products',
				display: 'productName',
				source: products,
				templates: {
          header: function(data) {
            if (data && data.query && data.query.length >= rcProps.get('search.visual.minLengthBeforeSearching')) {
            	switchInnerProductRecsHed();
                $('#js-search-hed-target').first().remove();
                checkRecsScrollPos();
                return rcProps.get('search.visual.templates.headerRelated');
            } else {
            	switchInnerProductRecsHed();
                $('#js-search-hed-target').first().remove();
                checkRecsScrollPos();
                return rcProps.get('search.visual.templates.headerRecent');
            }
					},
					suggestion: (function () {
						var template = rcProps.get('search.visual.templates.line');
						return function (data) {
							return Mustache.render(template, data);
						}
					}())
				},
				limit: rcProps.get('search.visual.limit')
			});
		}

	 // Creates typeahead feature on search box.
	 var textbox = $('.js-site-search__textbox');

	 textbox.typeahead.apply(textbox, sources)
		.on('typeahead:select', function (event, suggestion) {
			logEngagement('click_search_suggestion_' + (suggestion.termType || 'search'));
			let redirectUrl;

			if ('productURL' in suggestion) {
                  redirectUrl = suggestion.productURL;
				// window.location.href = suggestion.productURL;
			} else if ('suggestionUrl' in suggestion) {
                  redirectUrl = suggestion.suggestionUrl;
                  // window.location.href = suggestion.suggestionUrl;
			} else {
                  //call to SearchController will handle inserting recent search to redis
                  window.location.href = '/content/s/ct?type=' + suggestion.typeShortCode + '&q=' + suggestion.searchTerm + '&s=' + suggestion.suggestion + '&d=' + rcProps.get('department');
			}

              insertSuggestedText(suggestion.suggestion, function() {
                  window.location.href = redirectUrl;
			});
		});

		// Stacked Search Suggestion Layout
		$('.tt-dropdown-menu')
			.addClass('site-search__predictions')
			.css({
				'left': '',
				'z-index': '',
				'right': ''
			});
		$('.twitter-typeahead').addClass('site-search__typeahead form-search__input').css({ display: 'inline-block' });
		$('.tt-dataset-textSuggestions').addClass('site-search__suggestions');
		$('.tt-dataset-products').addClass('g').addClass('n-block-grid--2');
		$('.site-search__results ul').first().removeClass('g n-block-grid--2');
		$('.site-search__results ul').next().removeClass('g n-block-grid--2 n-block-grid--2-products').addClass('horizontal-scroll u-flex form-search__scroll');
		$('.site-search__results').appendTo('.form-search__wrap');
		$('.tt-highlight').addClass('site-search__highlight');
		$('.tt-dataset-products').addClass('predict-related');
		$('.site-search__results').insertAfter('.twitter-typeahead');
		$('.site-search__results').css({ width: '100%' });
		$('#recent-searched-viewed').insertAfter('.site-search__results > .n-block-grid--2-textSuggestions');

	}

	$.fn.changeElementType = function(newType) {
    var attrs = {};

    $.each(this[0].attributes, function(idx, attr) {
      attrs[attr.nodeName] = attr.nodeValue;
    });

    this.replaceWith(function() {
      return $('<' + newType + '/>', attrs).append($(this).contents());
    });
  }

	function logEngagement(action) {
		console.log('logEngagement("' + action + '")');
		$.ajax({
			type: 'POST',
			data: $.param({
				url: window.location.href,
				module: 'mobile_search',
				action: action

			}),
			url: '/r/ajax/LogEngagement.jsp'
		});
	}

  function insertSuggestedText(suggestedText, callback) {
      $.ajax({
          type: 'POST',
          data: $.param({
              searchText: suggestedText

          }),
          url: '/r/ajax/InsertRecentSearch.jsp',
          complete:function () {
			if(typeof callback == 'function'){
				callback();
			}
          }
      });
  }

	function initEventHandlers() {
		// get vars
		var $favoritesBtn = $('#tr_top_heart_mhp');
		var $fittingRoomBtn = $('#tr-fittingroom-target');
		var $cartBtn = $('#tr_top_bag_mhp');
		var $searchBtn = $('#tr_top_search_btn');
		var $revolveLogo = $('#rev-logo');
		var $backToNav = $('.form-search__back');
		var $clearSearchBtn = $('.js-toggle-form-search-x');
		var $searchForm = $('.js-search-form');
		var $searchFormBlock = $('.js-search-form-block');
		var $recentSearchedViewed = $('#recent-searched-viewed');
		var $burgerMenu = $('#tr-burger-icon');
		var $searchInput =$('.js-site-search__textbox');
		var $submitSearch = $('.form-search__submit');
		var $searchResults = $('.site-search__results');
		var $headerHeight = $('header').height();
		var $searchHorizontalScroll = $('.ui-list.horizontal-scroll.u-flex');

		//register clicks and toggle classes

		$('.tt-input').on('typeahead:asyncreceive',function(ev, suggestion) {
			$('#ariaSearchContainer').empty();
			var totalResults = $('.site-search__results ul li').length;
			$('#ariaSearchContainer').append(totalResults + ' results are available');

		})
		//search initialized
		function triggerSearch() {
			var $siteHeader = $('.site-header');
			var $searchFormContianer = $('.js-search-form-block');
			var searchFormActive = $searchForm.hasClass('is-displayed');
			$siteHeader.css('padding-bottom', '0');
			$('.form-search__wrap').appendTo('body');
			$('.form-search__wrap').show();
			if(!searchFormActive) {
				$searchForm.addClass('is-displayed');
				$backToNav.addClass('is-active');
				$siteHeader.addClass('search-is-active');
				if($('.form-search__scroll').length > 0) {
					$('.form-search__scroll').addClass('form-search__scroll--active');
				}
				$(`<div class='form-search-overlay'></div>`).appendTo('body').on('click', function() {
					endSearch();
				});
				$searchForm.attr('toggle-body-lock', 'true');
				disableBodyScroll($('.site-search__results')[0]);
			}
			$burgerMenu.hide();
			$revolveLogo.hide();
			$searchBtn.hide();
			$favoritesBtn.hide();
			if ($fittingRoomBtn !== undefined) {
				$fittingRoomBtn.hide();
			}
		 	$cartBtn.hide();
			$searchForm.show();
			$searchInput.focus();
			$searchFormBlock.attr('aria-modal', 'true');
			Keyboard.trapFocus($searchFormContianer);
		}


		// submit or back to navigation
		function endSearch() {
			var searchFormActive = $searchForm.hasClass('is-displayed');
			var $searchFormContianer = $('.js-search-form-block');
			var $siteHeader = $('.site-header');
			if (searchFormActive) {
				$searchForm.removeClass('is-displayed');
				$('.form-search__wrap').hide();
				$backToNav.removeClass('is-active');
				$siteHeader.css('padding-bottom', '');
				$siteHeader.removeClass('search-is-active');
				$('.form-search-overlay').remove();
				$searchForm.attr('toggle-body-lock', '');
				enableBodyScroll($('.site-search__results')[0]);
			}
			$searchForm.hide();
			$revolveLogo.show();
			$searchBtn.show();
			$favoritesBtn.show();
			if ($fittingRoomBtn !== undefined) {
				$fittingRoomBtn.show();
			}
			$cartBtn.show();
			$searchFormBlock.attr('aria-modal', 'false');
			Keyboard.releaseFocus($searchFormContianer);
			if(backButtonPresent) {
				$backButton.show();
			} else {
				$burgerMenu.show();
			}
			$searchBtn.trigger('focus');
		}
		//clear typed characters
		function clearSearch() {
			$searchInput.typeahead('val', '');
			$searchInput.focus();
			$searchResults.hide();
      $('.site-search__results').find('.n-block-grid--2-textSuggestions').html(''); // try to clear search suggestions
      $('.site-search__results > .ui-list.horizontal-scroll.u-flex').scrollLeft(0, 0);
		}
		$searchBtn.on('click', function(event) {
				triggerSearch(event);
		});
		$clearSearchBtn.on('click', function() {
			clearSearch();
			$searchForm.removeClass('form-search--full');
		});
		$submitSearch.on('click', function() {
			endSearch();
		});
		$backToNav.on('click', function() {
			endSearch();
		});
		$searchInput.on('focus', function() {
			$(this).val('');
		});
		$searchInput.on('input', function() {
			if ($(this).val().length > 0) {
				$searchForm.addClass('form-search--full');
			} else {
				$searchForm.removeClass('form-search--full');
			}
		});
	}

	return {
		init: function() {
			if(!$('.js-site-search__textbox').length) {
				return;
			}
			initTypeahead();
			initEventHandlers();
		}
	};
}());



// WEBPACK FOOTER //
// ./src/scripts/modules/search.js